var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-event-activity',{staticClass:"card-icon is-size-2 is-ellipsed icon-activities has-text-secondary",attrs:{"event-activity":_vm.eventActivity}})
}
var staticRenderFns = []

export { render, staticRenderFns }